import { useState } from "react";
import { motion } from "framer-motion";
import { Radio, Subtitles } from "lucide-react";
import { YOUTUBE } from "@/lib/constants";
import { useI18n } from "@/i18n/I18nContext";

export const LiveBroadcast = () => {
  const { t, lang, languages } = useI18n();
  const [sub, setSub] = useState(lang);

  const base = YOUTUBE.channelId
    ? `https://www.youtube.com/embed/live_stream?channel=${YOUTUBE.channelId}`
    : `https://www.youtube.com/embed/${YOUTUBE.videoId}`;
  const src = `${base}${base.includes("?") ? "&" : "?"}cc_load_policy=1&cc_lang_pref=${sub}&hl=${sub}&rel=0&modestbranding=1`;

  return (
    <section id="direct" data-testid="live-section" className="relative py-28 md:py-36 px-6 lg:px-10 bg-theatre-surface/40">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-theatre-red mb-5 flex items-center justify-center gap-2">
            <Radio size={14} className="animate-pulse" /> {t("live.eyebrow")}
          </p>
          <h2 className="font-serif text-3xl md:text-5xl text-white">{t("live.title")}</h2>
          <p className="mt-5 text-neutral-400 max-w-2xl mx-auto">{t("live.subtitle")}</p>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="border border-theatre-gold/25 bg-black p-3 md:p-4"
        >
          <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-4 px-2">
            <div className="flex items-center gap-2 text-neutral-400">
              <Subtitles size={16} className="text-theatre-gold" />
              <label htmlFor="sub-lang" className="text-xs uppercase tracking-[0.2em]">{t("live.subLabel")}</label>
            </div>
            <select
              id="sub-lang"
              data-testid="live-subtitle-select"
              value={sub}
              onChange={(e) => setSub(e.target.value)}
              className="bg-black border border-white/20 text-white text-sm px-4 py-2 focus:outline-none focus:border-theatre-gold cursor-pointer"
            >
              {languages.map((l) => (
                <option key={l.code} value={l.code}>{l.flag} {l.label}</option>
              ))}
            </select>
          </div>

          <div className="relative w-full" style={{ aspectRatio: "16 / 9" }}>
            <iframe
              key={sub}
              data-testid="live-iframe"
              src={src}
              title="VIVA ARTIST — Direct"
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </motion.div>
      </div>
    </section>
  );
};
